import { LoadingOutlined } from '@ant-design/icons';
import { Button, Space, Spin, Table, Tag } from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import customPassService from '../../../services/config/custom_pass.service';

const PeriodPassList = ({ search, refresh, }) => {
    const [state, setState] = useState({
        loading : false,
        period_passes : [],
        count : 0,

        // pagination
        display_size : 10,
        page : 1,
    })

    const paginateChange = (page) => {
        setState(state => ({...state, page : page}));
    }

    const fetchPeriodPasses = async () => {
        setState(state => ({...state, loading : true, }));

        const periodPassResponse = await customPassService?.getPeriodPassListing({
            page : (state?.page - 1),
            size : state?.display_size,
            search : search,
        });

        const { period_passes } = periodPassResponse;
        setState(state => ({...state, loading : false, period_passes : period_passes?.rows, count : period_passes?.count, }));
    }

    useEffect(() => {
        setState(state => ({...state, page : 1}));
    }, [search])

    useEffect(() => {
        fetchPeriodPasses();
    }, [state?.page, search, refresh])

    return (
        <>
            <Spin spinning={state?.loading} indicator={<LoadingOutlined />}>
                <Table
                dataSource={state?.period_passes}
                scroll={{x : 400,}}
                pagination={{
                    size : state?.display_size,
                    showSizeChanger : false,
                    total : state?.count,
                    current : parseInt(state?.page),
                    onChange : (page) => paginateChange(page),
                }}
                className='hub-table bordered'
                columns={[{
                    title : 'Prefix',
                    dataIndex : 'prefix',
                    key : 'prefix',
                },{
                    title : 'Quantity',
                    dataIndex : 'quantity',
                    key : 'quantity',
                },{
                    title : 'Parks',
                    dataIndex : 'parks',
                    key : 'parks',
                    render : (parks, row, index) => {
                        return (
                            <Space wrap key={index}>
                            {
                                parks?.map((park, index) => {
                                    const { name } = park ?? {};
                                    return (
                                        <Tag key={index} style={{background : 'var(--secondary-button-color)', color : 'var(--secondary-text-color)', border:'none',}}>
                                            {name}
                                        </Tag>
                                    )
                                })
                            }
                            </Space>
                        )
                    }
                },{
                    title : 'From Date',
                    dataIndex : 'start_date',
                    key : 'start_date',
                    render : (start_date) => {
                        return start_date ? moment(start_date)?.format("YYYY-MM-DD") : '-';
                    }
                },{
                    title : 'End Date',
                    dataIndex : 'end_date',
                    key : 'end_date',
                    render : (end_date) => {
                        return end_date ? moment(end_date)?.format("YYYY-MM-DD") : '-';
                    }
                },{
                    title : 'Created Date',
                    dataIndex : 'created_at',
                    key : 'created_at',
                    render : (created_at) => {
                        return moment(created_at)?.format("YYYY-MM-DD HH:mm:ss");
                    }
                },{
                    title : 'Action',
                    dataIndex : 'period_pass_id',
                    key : 'period_pass_id',
                    width : '10%',
                    render : (period_pass_id) => {
                        return (
                            <Link to={`/custom/pass/period/detail/${period_pass_id}`}>
                                <Button>View</Button>
                            </Link>
                        )
                    }
                },]}
                />
            </Spin>
        </>
    );
}

export default PeriodPassList;
